import { render, staticRenderFns } from "./FormPublish.vue?vue&type=template&id=ef21d14e"
import script from "./FormPublish.vue?vue&type=script&lang=js"
export * from "./FormPublish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports